<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      />
    </v-overlay>
    <v-card
      width="100%"
      v-show="!overlay"
    >
      <v-card-title>
        <v-row>
          <v-col cols="6">
            <v-select
              v-model="selectedReportType"
              :items="reportTypes"
              item-text="label"
              item-value="key"
              label="Select Report Type"
              outlined
              hide-details
              return-object
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="selectedReportType">
        <component
          :is="selectedReportType.component"
          :params="selectedReportType.params"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import KeyVehicleAllocation from "@/reports/KeyVehicleAllocation";
import UserBookingDetailsVue from './UserBookingDetails.vue';
import VehicleBookingDetailsVue from './VehicleBookingDetails.vue';
import AssetGroupBookingDetailsVue from './AssetGroupBookingDetails.vue';

export default {
  data() {
    return {
      overlay: false,
      users: [],
      assetGroups: [],
      assetTypes: [],
      assets: [],
      vehicles: [],
      reportTypes: [
        {
          key: 'key_vehicle_allocation',
          label: 'Key Vehicle Allocation',
          component: KeyVehicleAllocation,
          params: {
            cabinets: [],
            assets: [],
            vehicles: [],
          },
        },
        {
          key: 'user_booking_details',
          label: 'User Booking Details',
          component: UserBookingDetailsVue,
          params: {
            users: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'vehicle_booking_details',
          label: 'Vehicle Booking Details',
          component: VehicleBookingDetailsVue,
          params: {
            users: [],
            vehicles: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'asset_group_booking_details',
          label: 'Asset Group Booking Details',
          component: AssetGroupBookingDetailsVue,
          params: {
            assetGroups: [],
            assetTypes: [],
          },
        },
      ],
      selectedReportType: "",
    };
  },
  created() {
    this.$store.dispatch("GET_GEOFENCES")
      .then(() => {
        this.reportTypes.map((reportType) => {
          if (reportType.params.hasOwnProperty('geofences')) {
            reportType.params.geofences = this.geofences;
          }
          return reportType;
        });
      })
    this.$store.commit("CLEAR_CABINETS");
    this.$store.dispatch("LOAD_CABINETS")
      .then(() => {
        this.reportTypes.map((reportType) => {
          if (reportType.params.hasOwnProperty('cabinets')) {
            reportType.params.cabinets = this.cabinets;
          }
          return reportType;
        });
      });
    this.getDataUsers();
    this.getDataVehicleGroups();
    this.getDataAssetTypes();
    this.getDataAssets();
    this.getDataVehicles();
  },
  computed: {
    cabinets() {
      return this.$store.getters.getCabinets;
    },
    geofences() {
      return this.$store.getters.getGeofencesData;
    },
  },
  methods: {
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    getDataVehicleGroups() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_groups",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.assetGroups = response.data.data.filter(group => {
            const noBookingRequired = this.getValueAsBoolean(group.metadata.no_booking_required);
            const isSpecial = this.getValueAsBoolean(group.metadata.is_special);
            return !noBookingRequired && !isSpecial;
          });
          this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('assetGroups')) {
              reportType.params.assetGroups = this.assetGroups;
            }
            return reportType;
          });
        });
    },
    getDataAssetTypes() {
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_types',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.assetTypes = response.data.data;
        });
    },
    getDataAssets() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_assets",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.assets = response.data.data;
          this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('assets')) {
              reportType.params.assets = this.assets;
            }
            return reportType;
          });
        });
    },
    getDataVehicles() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_vehicles",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.vehicles = response.data.data;
          this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('vehicles')) {
              reportType.params.vehicles = this.vehicles;
            }
            return reportType;
          });
        });
    },
    getDataUsers() {
      this.$store
        .dispatch("API_CALL", {
          $method: "get_all",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.users = response.data.data;
          this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('users')) {
              reportType.params.users = this.users;
            }
            return reportType;
          });
        });
    },
  },
};
</script>
